import naja from 'naja';
import RangePriceInputs from './RangePriceInputs';
import ProductThumbsSlider from './ProductThumbsSlider';
import ProductLabel from './ProductLabel';

export default class Filter {
    static init() {
        this.initFilterForm();
        RangePriceInputs.init();
        ProductThumbsSlider.init();
        ProductLabel.init();
        this.handleToggleLoadMore();

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--products') {
                ProductThumbsSlider.destroy();
                ProductThumbsSlider.init();
                ProductLabel.init();
            }

            if (event.detail.snippet.id === 'snippet-productFilter-categoryList-filters') {
                this.initFilterForm();
                RangePriceInputs.init();
                ProductThumbsSlider.destroy();
                ProductThumbsSlider.init();
                ProductLabel.init();
            }
        });
    }

    static initFilterForm() {
        const formInputs = document.querySelectorAll('#frm-productFilter-filterForm input');
        const form = document.querySelector('#frm-productFilter-filterForm');

        if (formInputs.length > 0) {
            formInputs.forEach((input) => {
                const clone = input.cloneNode(true);
                if (input.parentNode) {
                    input.parentNode.replaceChild(clone, input);
                    clone.addEventListener('change', () => {
                        if (form instanceof HTMLFormElement) {
                            naja.uiHandler.submitForm(form);
                        }
                    });
                }
            });
        }
    }

    static handleToggleLoadMore() {
        // Handle load more button to append products instead of replacing them
        document.addEventListener('click', function (e) {
            const target = e.target as HTMLElement;
            const loadMoreButton = target.closest('#load-more-button');

            if (loadMoreButton) {
                // Set append mode for the products snippet before the request
                const productsContainer = document.querySelector('[id="snippet--products"]');
                if (productsContainer) {
                    productsContainer.setAttribute('data-naja-snippet-append', 'true');
                }
            }
        });

        // Clean up append attribute after non-load-more requests
        naja.addEventListener('before', (event) => {
            const url = new URL(event.detail.url as string);
            const isLoadMore = url.searchParams.has('page') && parseInt(url.searchParams.get('page') || '1') > 1;

            if (!isLoadMore) {
                // Remove append mode for regular filter changes
                const productsContainer = document.querySelector('[id="snippet--products"]');
                if (productsContainer) {
                    productsContainer.removeAttribute('data-naja-snippet-append');
                }
            }
        });
    }
}